/** @format */

import { ChangeDetectionStrategy, Component, PLATFORM_ID, computed, inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { DeviceService, WINDOW } from '@shared/data-access/services';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconChevronLeft
} from '@dsg-tech/homefield-angular-icons';

import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { chain } from '@core/chain';

@Component({
	selector: 'pdp-back-to-search-results',
	templateUrl: './back-to-search-results.component.html',
	styleUrl: './back-to-search-results.component.scss',
	imports: [HmfButtonComponent, HomefieldIconLibraryModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BackToSearchResultsComponent {
	public chain = chain;

	private readonly platformId = inject(PLATFORM_ID);
	private readonly window = inject(WINDOW);
	private readonly document = inject(DOCUMENT);
	private readonly deviceService = inject(DeviceService);
	private readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	private readonly isDesktop = computed(() =>
		isPlatformBrowser(this.platformId) ? this.deviceService.isDesktop() : false
	);

	private readonly referrer = computed(() =>
		isPlatformBrowser(this.platformId) ? this.document.referrer : ''
	);

	private readonly comingFromSlrpOrPlp = computed(() => {
		if (typeof this.referrer() === 'string') {
			return (
				this.referrer().indexOf('/f/') > -1 ||
				this.referrer().indexOf('/SearchDisplay') > -1
			);
		}
		return false;
	});

	public readonly backButtonText = computed(() => {
		if (typeof this.referrer() === 'string' && this.referrer().indexOf('/f/') > -1) {
			return 'BACK TO RESULTS';
		}
		return 'BACK TO SEARCH RESULTS';
	});

	public readonly dataEmText = computed(() => {
		if (typeof this.referrer() === 'string') {
			if (this.referrer().indexOf('/f/') > -1) {
				return 'PDP_BackToResults';
			} else if (this.referrer().indexOf('/SearchDisplay') > -1) {
				return 'PDP_BackToSearchResults';
			}
		}
		return '';
	});

	public readonly shouldShowBackButton = computed(
		() => this.isDesktop() && this.comingFromSlrpOrPlp() && this.window.history.length > 1
	);

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([homefieldIconChevronLeft]);
	}

	public backToSearchResults() {
		this.window.history.back();
	}
}
